import { CandidateEndpoints, RequestMethods, useRequest } from '@src/shared';

import type { CommonResponse, RequestDeps } from '@shared/types';

import type {
  CreateCandidateRequestParams,
  CreateCandidateRequestResponse,
} from './types';

export const useCreateCandidate = (
  request: CreateCandidateRequestParams,
  deps: RequestDeps
) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    CreateCandidateRequestParams,
    CreateCandidateRequestResponse,
    CommonResponse
  >({
    params: {
      key: 'createCandidate',
      method: RequestMethods.POST,
      url: `${CandidateEndpoints.CANDIDATES}/draft`,
      request,
      fetchManual: true,
      deps,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
